// @ts-nocheck
import { StoreListModel } from "@store/Framework/Types/ApiModels";
import { getStoreList, GetStoreListApiParameter } from "@store/Services/StoreListService";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface LoadStoreListResult {
    apiResult: StoreListModel;
}

type HandlerType = Handler<GetStoreListApiParameter, LoadStoreListResult>;

export const DispatchBeginLoadStoreList: HandlerType = props => {
    props.dispatch({
        type: "Data/StoreLists/BeginLoadStoreList",
        storeListId: props.parameter.storeListId,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getStoreList(props.parameter);
    } catch (error) {
        if ("status" in error && error.status === 404) {
            props.dispatch({
                type: "Data/StoreLists/FailedToLoadStoreList",
                storeListId: props.parameter.storeListId,
                status: 404,
            });
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteLoadStoreList: HandlerType = ({ dispatch, apiResult }) => {
    dispatch({
        type: "Data/StoreLists/CompleteLoadStoreList",
        storeList: apiResult,
    });
};

export const chain = [DispatchBeginLoadStoreList, RequestDataFromApi, DispatchCompleteLoadStoreList];

const loadStoreListData = createHandlerChainRunner(chain, "LoadStoreList");
export default loadStoreListData;
